import { handleErrors } from './ErrorActions';
import * as savedSearchesApi from '../api/saved-searches';
import * as translationsApi from '../api/translations';

export const GET_SAVED_SEARCHES_BY_ENTITY = 'GET_SAVED_SEARCHES_BY_ENTITY';
export const GET_SAVED_SEARCHES_BY_ENTITY_SUCCESS = 'GET_SAVED_SEARCHES_BY_ENTITY_SUCCESS';
export const GET_SAVED_SEARCHES_BY_ENTITY_FAILURE = 'GET_SAVED_SEARCHES_BY_ENTITY_FAILURE';
export const SAVED_SEARCHES_PAGE_TITLE = 'SAVED_SEARCHES_PAGE_TITLE';
export const FORCE_SAVED_SEARCH_REFRESH = 'FORCE_SAVED_SEARCH_REFRESH';

export const getSavedSearchesByEntitySuccess = (entityName, searches, groups) => ({
  type: GET_SAVED_SEARCHES_BY_ENTITY_SUCCESS,
  payload: {
    entityName,
    searches,
    groups,
  },
});

export const getSavedSearchesByEntityFailure = (entityName, error) => ({
  type: GET_SAVED_SEARCHES_BY_ENTITY_FAILURE,
  payload: {
    entityName,
    error,
  },
});

export const getSavedSearchesByEntity = (entityName) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SAVED_SEARCHES_BY_ENTITY,
      payload: {
        entityName,
      },
    });

    const apiData = await savedSearchesApi.getSavedSearchesByEntity(entityName);

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      dispatch(getSavedSearchesByEntityFailure(entityName, apiData.errors));
    } else {
      dispatch(
        getSavedSearchesByEntitySuccess(
          entityName,
          apiData.savedSearches,
          apiData.groupedSavedSearches
        )
      );
    }
  } catch (error) {
    dispatch(handleErrors(error));
    dispatch(getSavedSearchesByEntityFailure(entityName, error));
  }
};

export const translatePageTitle = (translationKey) => async (dispatch) => {
  let translatedValue = translationKey;

  const apiData = await translationsApi.translateString(translationKey);

  if (apiData.hasError) {
    dispatch(handleErrors(apiData.errors));
  } else {
    translatedValue = apiData.Translation;
  }

  dispatch({
    type: SAVED_SEARCHES_PAGE_TITLE,
    pageTitle: translatedValue,
  });
};

export const forceSavedSearchRefresh = (entityName, flag) => ({
  type: FORCE_SAVED_SEARCH_REFRESH,
  payload: {
    entityName,
    flag,
  },
});
